import React, { Component, ErrorInfo, ReactNode } from 'react';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { useNavigate } from 'react-router-dom';
import { usePopUpNotifications } from 'src/hooks';

interface Props {
  navigate: NavigateFunction;
  addErrorNotification: (error?: unknown, timeout?: number) => void;
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryComponent extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Application error:', error, errorInfo);
    this.props.addErrorNotification('error.reactError', 5000);
    this.props.navigate('/');
    setTimeout(() => {
      this.setState({ hasError: false });
    }, 100);
  }

  public render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export const ErrorBoundary: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { addErrorNotification } = usePopUpNotifications();

  return (
    <ErrorBoundaryComponent
      navigate={navigate}
      addErrorNotification={addErrorNotification}
    >
      {children}
    </ErrorBoundaryComponent>
  );
};

export default ErrorBoundary;
